export default __webpack_public_path__ + "media/images/terminfinder_solution-2a5b9058ecc819e70bef08738cadc90e.png";